import React from 'react';
import pick from 'lodash/pick';
import RadioField from 'components/pure/utils/form/RadioField';
import CoachingContentDetail, {defaultSkillGoal} from 'records/CoachingContentDetail';
import SkillContentDetail from './SkillContentDetail';
import TextAreaField from 'components/pure/utils/form/TextAreaField';
import get from 'lodash/get';
import {validate} from 'records/CoachingPlan';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import {List} from 'immutable';
import './ContentStep.styl';

export default class ContentStep extends React.PureComponent {
  static title = 'Content';

  static validate(plan) {
    return pick(validate(plan), ['contentDetails']);
  }

  setIsSkillBased(isSkillBased) {
    const {model: coachingPlan, onChange} = this.props;
    const alreadySet = coachingPlan.contentDetails.some(
      detail => detail.isSkillBased === isSkillBased
    );
    // cannot have both
    !alreadySet &&
      onChange(
        coachingPlan.set(
          'contentDetails',
          List([
            new CoachingContentDetail({
              isSkillBased,
              skillGoal: isSkillBased ? defaultSkillGoal : undefined,
            }),
          ])
        )
      );
    requestAnimationFrame(() => this.inputRef && this.inputRef.focus());
  }

  // TODO: a must be replaced with button and eslint ignore must be removed
  /* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
  render() {
    const {model: coachingPlan, skills, onChange, showErrors, frozen} = this.props;
    const {contentDetails} = coachingPlan;
    const isSkillBased = contentDetails.some(detail => detail.isSkillBased);
    const errors = ContentStep.validate(coachingPlan);
    const recipient = coachingPlan.recipient.info;
    return (
      <div className="coaching-step coaching-plan-wizard-content-step">
        <p>What will you coach?</p>
        <RadioField
          label="Skill/s"
          disabled={frozen}
          checked={isSkillBased}
          onClick={() => this.setIsSkillBased(true)}
        />
        {isSkillBased && (
          <div>
            {contentDetails.map((detail, i) => (
              <SkillContentDetail
                disabled={frozen}
                key={i}
                recipient={recipient}
                skills={skills}
                coachingPlan={coachingPlan}
                detail={detail}
                isLast={i === contentDetails.size - 1}
                showClose={contentDetails.size === 2}
                errors={showErrors && get(errors, ['contentDetails', i])}
                onChange={detail => {
                  onChange(coachingPlan.setIn(['contentDetails', i], detail));
                }}
                onRemove={() =>
                  onChange(coachingPlan.set('contentDetails', contentDetails.remove(i)))
                }
              />
            ))}
            {!frozen && contentDetails.size < 2 && (
              <a
                href="javascript:"
                className="generic-link"
                onClick={() =>
                  onChange(
                    coachingPlan.set(
                      'contentDetails',
                      contentDetails.push(
                        new CoachingContentDetail({
                          isSkillBased: true,
                          skillGoal: defaultSkillGoal,
                        })
                      )
                    )
                  )
                }>
                + Add secondary skill to coach
              </a>
            )}
          </div>
        )}
        <RadioField
          disabled={frozen}
          label="Custom"
          checked={!isSkillBased}
          onClick={() => this.setIsSkillBased(false)}
        />
        {!isSkillBased &&
          contentDetails.map((detail, i) => (
            <FieldContainer
              labelType="div"
              key={i}
              error={showErrors ? get(errors, ['contentDetails', i, 'custom']) : null}>
              <TextAreaField
                disabled={frozen}
                value={detail.custom || ''}
                onChange={value =>
                  onChange(coachingPlan.setIn(['contentDetails', i, 'custom'], value))
                }
                rows="3"
                placeholder="Describe what will be coached during this plan"
                inputRef={ref => (this.inputRef = ref)}
              />
            </FieldContainer>
          ))}
      </div>
    );
  }
}
